import React from "react"
import styled from "styled-components"

export const ArrowLeft = (props) => {
  const { onClick } = props
  return (
    <SliderButton style={{ left: 0 }} onClick={onClick}>
      <svg className="button-icon" viewBox="0 0 100 100">
        <path
          d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
          className="arrow"
        ></path>
      </svg>
    </SliderButton>
  )
}
export const ArrowRight = (props) => {
  const { onClick } = props
  return (
    <SliderButton style={{ right: 0 }} onClick={onClick}>
      <svg className="button-icon" viewBox="0 0 100 100">
        <path
          d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
          className="arrow"
          transform="translate(100, 100) rotate(180) "
        ></path>
      </svg>
    </SliderButton>
  )
}

const SliderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 0;
  background-color: #fff;
  z-index: 100;
  transition: all 0.1s ease-in-out;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  background: hsla(0, 0%, 100%, 0.75);
  border: none;
  color: #333;

  :hover {
    color: #a6a6a6;
  }

  .button-icon {
    position: absolute;
    left: 20%;
    top: 35%;
    width: 60%;
    height: 30%;
    fill: currentColor;
  }
`
